export const FIREBASE_URL_LOCAL = 'http://127.0.0.1:5001/aigen-bee24/us-central1';
export const FIREBASE_URL_PROD = 'https://us-central1-aigen-bee24.cloudfunctions.net';
